import { render, staticRenderFns } from "./IndexView.vue?vue&type=template&id=daef7a7e"
import script from "./IndexView.vue?vue&type=script&lang=js"
export * from "./IndexView.vue?vue&type=script&lang=js"
import style0 from "./IndexView.vue?vue&type=style&index=0&id=daef7a7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports